export default class ViewsSystemSettingsVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	breadcrumbMember = true;
	breadcrumbMemberOverridable = false;

	exposeEditableBreadcrumb = false;

	mainMenuMember = true;
	mainMenuMemberOverridable = true;

	subMenuMember = false;
	subMenuMemberOverridable = false;

	iconEditor = 'default';
	useSameIconsAsInEditorInFrontEnd = false;

	useIconsInFrontEnd = false;
	iconFrontEnd = 'default';
	iconFrontEndOverridable = false;
	exposeIconFrontEndToEditor = false;

	showInSearch = true;
	showInSearchOverridable = false;

	enableSeo = true;
	enableSeoOverridable = false;

	preloadFlow = 'preloadAfterLastTransitionOut';
	preloadFlowOverridable = false;

	depth = 'default';
	depthOverridable = false;

	constructor()
	{
		
	}
}